<template>
    <!-- 분포가 없으면 아무것도 그리지 않는다. 부르는 쪽이 기존 진행현황 뱃지를 그대로 그린다.
         (정본 §4 안전 원칙 — 새 필드가 없다고 화면이 비면 안 된다) -->
    <div v-if="dist && dist.줄 && dist.줄.length" class="progress-dist">
        <div v-for="(row, i) in dist.줄" :key="'pd-' + i" class="progress-dist__row">
            <span class="badge" :class="badgeClass(row.상태)">{{ row.상태 }}</span>
            <span class="progress-dist__qty">{{ row.수량.toLocaleString() }}</span>
        </div>
        <div v-if="showTotal && dist.구매요청수량 > 0" class="progress-dist__total">
            합 {{ dist.합계.toLocaleString() }} / {{ dist.구매요청수량.toLocaleString() }}
        </div>
    </div>
</template>

<script>
/**
 * 구매요청 한 건의 진행현황을 "상태 하나" 가 아니라 "수량 분포" 로 그린다.
 * 정본: docs/coupass-logistics-chain.md §4, §5 Phase 2-17.
 *
 * 선적이 여럿이면 상태를 하나로 고를 수 없다 —
 * "1차는 쿠팡센터입고완료, 2차는 아직 해외입고중" 을 한 칸에 못 담기 때문이다.
 *
 * 선적이 하나뿐이면 한 줄짜리라 지금 화면과 거의 같아 보인다.
 * 분포가 없으면(=선적 없음) 아무것도 안 그리므로, 부르는 쪽은 v-if 로 갈라
 * 기존 뱃지를 그대로 유지하면 된다.
 */
export default {
    name: 'ProgressDistribution',
    props: {
        // /api/reqpurchase/shipmentDistribution 의 분포[reqId]. 없으면 null
        dist: { type: Object, default: null },
        // 합계 줄을 보일지. 좁은 목록에서는 끈다
        showTotal: { type: Boolean, default: true }
    },
    methods: {
        badgeClass(상태) {
            const map = {
                '쿠팡센터입고완료': 'badge-success',
                '국내입고중': 'badge-primary',
                '국내창고입고완료': 'badge-success',
                '국내창고입고중': 'badge-dark',
                '해외입고중': 'badge-info',
                '출고완료': 'badge-warning',
                '중국창고': 'badge-secondary',
                '미도착': 'badge-light'
            };
            return map[상태] || 'badge-light';
        }
    }
};
</script>

<style lang="scss" scoped>
.progress-dist {
    display: inline-block;
    text-align: left;
    min-width: 130px;

    &__row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 6px;
        line-height: 1.5;
    }

    &__qty {
        font-variant-numeric: tabular-nums;
        font-weight: 600;
    }

    &__total {
        border-top: 1px solid #e9ecef;
        margin-top: 2px;
        padding-top: 2px;
        font-size: 11px;
        color: #868e96;
        text-align: right;
    }
}
</style>
